// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-bg{padding:10px 15px}.hover-bg:hover{background-color:rgba(239,173,2,.3333333333);border-radius:6px}", ""]);
// Exports
module.exports = exports;
